import { Injectable } from '@angular/core';
import { HttpUtilService } from './http-util.service';
import { of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertsService{
  loaded: boolean = false;
  alerts: any[];
  activeCount: number = 0;
  totalCount: number = 0;

  constructor(private http: HttpUtilService) { }

  getAlerts(search?: string, status?: string, page?: number, perPage?: number, sortBy?: string, sortAsc?: boolean) {
    console.log(search, status, page, perPage, sortBy, sortAsc);
    this.loaded = true;
    let url = "/api/alerts";
    const params = [];
    if (search) params.push(`searchTerm=${search}`);
    if (status === 'inactive') params.push(`inactive=true`);
    if (status === 'all') params.push(`inactive=all`);
    console.log(page, perPage, page && perPage);
    if (page && perPage) params.push(`pageNumber=${page - 1}`, `perPage=${perPage}`);
    if (sortBy && sortAsc !== undefined) params.push(`sortBy=${sortBy}`, `sortDir=${sortAsc ? "asc" : "desc"}`);
    console.log(params);
    url += `?${params.join("&")}`;
    return this.http.request("GET", url, null, null, true).pipe(
      tap((res: any) => {
        console.log(res);
        this.alerts = res.listItems || [];
        this.activeCount = res.active || 0;
        this.totalCount = res.total || 0;
      })
    );
  }

  getActiveCount() {
    if (!this.loaded) {
      this.getAlerts().subscribe();
    }
    return of(this.activeCount);
  } 

}
